import { render } from "./GenericPage.vue?vue&type=template&id=2cabe7f4&scoped=true"
import script from "./GenericPage.vue?vue&type=script&lang=ts"
export * from "./GenericPage.vue?vue&type=script&lang=ts"

import "./GenericPage.vue?vue&type=style&index=0&id=2cabe7f4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2cabe7f4"

export default script